import { User } from '../types';

/**
 * Права на действия с сотрудником считает сервер (флаги can* в ответе /api/v2/users) с учетом
 * права, скоупа и ранга. Здесь флаги только читаются: без флага действие недоступно.
 */
export const canUserEditTarget = (targetUser: User | null | undefined): boolean =>
  Boolean(targetUser && targetUser.canEditProfile === true);

/** Кнопки активации и блокировок в таблице */
export const isActivationButtonDisabled = (user: User): boolean => user.canToggleStatus !== true;
